var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFileUploadSolid = function SvgFileUploadSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.75a.74.74 0 0 1 .75-.75H15V9h-4c-.563 0-1-.438-1-1V4H4.5A1.5 1.5 0 0 0 3 5.5v13c0 .844.656 1.5 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-4H9.75a.722.722 0 0 1-.75-.75ZM11 4v4h4l-4-4Zm9.75 9.219-2.5-2.5c-.313-.281-.781-.281-1.063 0-.312.312-.312.781 0 1.062L18.438 13H15v1.5h3.438l-1.22 1.25a.622.622 0 0 0-.218.5c0 .219.063.406.219.531a.684.684 0 0 0 1.031 0l2.5-2.5c.313-.281.313-.75 0-1.062Z"
  })));
};

export default SvgFileUploadSolid;